//import { logout } from "../voim/action/UserAction";
import { myLog } from './Utility';
import store from '../sessionStorage';
import {
    checkWebConnect as IMcheckWebConnect,
    adminCheckWebConnect as IMadminCheckWebConnect,
} from '../voim/action/SocketActions';
import { networkChanged } from '../voim/action/NetworkAction';
import stores from '../stores';
import { RESPONSE_CONSTANT } from './ResponseConstant';
import { Student, Tutor } from './common/NamingTerms';

export let userSessionTimer;
export let userTokenRenewalTimer;
export let isPlaying = false;
let isSession = true;
//let lastActivityTime = Date.now();
//const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes in milliseconds
let logoutTimeout;

// Set isPlaying state
export const setIsPlaying = (playing) => {
    isPlaying = playing;
};

// Check if user is logged in
export const isLoggedIn = () => {
    const userSession = store.get('userSession');
    const adminSession = store.get('adminSession');
    const insAdminSession = store.get('insAdminSession');
    if (
        typeof userSession === 'object' ||
        typeof adminSession === 'object' ||
        typeof insAdminSession === 'object'
    ) {
        let timeStamp = Math.floor(Date.now() / 1000);
        // Check token expiry time
        if (userSession && (userSession.role === Tutor || userSession.role === Student)) {
            IMcheckWebConnect();
        }
        let isInsAdmin = false;
        if (
            insAdminSession &&
            (insAdminSession.role === RESPONSE_CONSTANT.INS_ADMIN ||
                insAdminSession.role === RESPONSE_CONSTANT.BRANCHADMIN ||
                insAdminSession.role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN)
        ) {
            isInsAdmin = true;
            IMadminCheckWebConnect();
        }
        if (isPlaying) {
            return true;
        }
        if (!isInsAdmin && userSession && userSession.expiry_time < timeStamp) {
            return false;
        } else if (isInsAdmin && insAdminSession && insAdminSession.expiry_time < timeStamp) {
            return false;
        } else {
            if (!userTokenRenewalTimer) {
                tokenRenewalTimeout();
            }
        }
        resetSessionTimer();
        return true;
    }
    // If userSession object is not present, return false
    return false;
};

// Reset session timer
const resetSessionTimer = () => {
    // lastActivityTime = Date.now();
    notifyActivity();
    clearTimeout(logoutTimeout);
    //scheduleLogout();
};

//scheduleLogout
// const scheduleLogout = () => {
//   const elapsedTime = Date.now() - lastActivityTime;
//   const remainingTime = INACTIVITY_LIMIT - elapsedTime;
//   logoutTimeout = setTimeout(
//     () => {
//       if (!isPlaying) {
//         logout(() => {
//           window.location.href = "/";
//         });
//       }
//     },
//     remainingTime > 0 ? remainingTime : 0
//   );
// };

//tokenRenewalTimeout
const tokenRenewalTimeout = () => {
    userTokenRenewalTimer = setInterval(() => {
        let currentDate = new Date();
        const userSession = store.get('userSession');
        if (
            userSession &&
            userSession.expiry_time &&
            userSession.expiry_time < currentDate.getTime()
        ) {
            // Uncomment and implement token renewal logic if needed
            // getRefreshToken((response) => {
            //   if (!response) {
            //     logout(() => {
            //       alert('Session timeout');
            //       window.location.href = '/';
            //     });
            //   }
            // });
        }
    }, 1000);
};

// Clear all timeouts and intervals
export const clearTimOutInterval = () => {
    isSession = false;
    removeEventListeners();
    //clearTimeout(logoutTimeout);
    clearInterval(userTokenRenewalTimer);
};

// Reset timeouts and intervals
export const resetTimeOutInterval = () => {
    isSession = true;
    addEventListeners();
    resetSessionTimer();
};

// Restart interval
export const restartInterval = () => {
    clearTimeout(logoutTimeout);
    if (isSession) {
        // resetSessionTimer();
    }
};

//notifyActivity
const notifyActivity = () => {
    localStorage.setItem('lastActivityTime', Date.now().toString());
};

//activityEventHandler
const activityEventHandler = () => {
    if (isLoggedIn()) {
        resetSessionTimer();
    }
};

// Add event listeners
const addEventListeners = () => {
    document.addEventListener('keydown', activityEventHandler);
    document.addEventListener('mousemove', activityEventHandler);
    document.addEventListener('scroll', activityEventHandler);
};

// Remove event listeners
const removeEventListeners = () => {
    document.removeEventListener('keydown', activityEventHandler);
    document.removeEventListener('mousemove', activityEventHandler);
    document.removeEventListener('scroll', activityEventHandler);
};

// Initial event listener setup
document.addEventListener('DOMContentLoaded', () => {
    addEventListeners();
    if (isLoggedIn()) {
        resetSessionTimer();
    }
});

window.addEventListener('offline', () => {
    myLog('offline');
    stores.dispatch(networkChanged(false));
});

window.addEventListener('online', () => {
    myLog('online');
    stores.dispatch(networkChanged(true));
});
